import { tipoDeSuscripcionesIdProducto } from "../Config/Suscripciones"

export const esSuscriptorDigital = (idProducto)=>{ 
    return idProducto === tipoDeSuscripcionesIdProducto.suscriptorDigital
}